// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Close from "@awc/XDL/Icons/Close";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xBaseTheme } from "@awc/XDL/types";
import { color, styledScrollbar, xScreen } from "@awc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import ModalPresentationPropsDefault from "@insite/mobius/Modal/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

export default {
    sizeVariants: {
        small: 430,
        medium: 800,
        large: 1110,
    },
    defaultProps: {
        ...ModalPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            headlineTypography: css`
                margin-bottom: 0;
                letter-spacing: 0;
            `,
            modalTitle: css`
                position: relative;
                padding: 12px 12px 4px;
                border-bottom: 0;
            `,
            modalContent: css`
                padding: 15px;
                ${styledScrollbar()}
            `,
            modalBody: css`
                background-color: ${color("common.white")};
                &&& {
                    box-shadow: 0 0 10px 0 ${color("common.ui7", 0.4)};
                }
                overflow: hidden;
                ${xScreen("lt", "md")} {
                    max-width: 90%;
                    height: auto;
                    max-height: calc(100% - 30px);
                    margin: 15px;
                }
            `,
            modalContainer: css`
                align-items: flex-start;
            `
        },
        headlineTypographyProps: {
            variant: "h2",
            css: css`
                margin-bottom: 0;
            `,
        },
        closeButtonProps: {
            mergeCss: true,
            variant: "link" as any,
            css: css`
                width: 16px;
                height: 16px;
                & > ${IconWrapper} {
                    color: ${color("common.ui5")};
                }
                &:not(:disabled):hover,
                &:not(:disabled):focus {
                    > ${IconWrapper} {
                        color: ${color("common.ui8")};
                    }
                }
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: Close,
            color: "common.ui5",
            size: 16,
            css: css`
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            `,
        },
    },
} as xBaseTheme["modal"];
